import React from 'react';
import { Button, Typography, Stack } from '@material-ui/core';
import { Dialog } from '@mui/material';

import { useNavigate } from 'react-router';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Checkmark } from 'react-checkmark';
import ErrorIcon from '@mui/icons-material/Error';
import { useMutation } from 'react-query';
import { queryClient } from 'src';
import PulseLoader from 'src/components/loaders/PulseLoader';

var timeoutId;
function ConfirmationDialogue({
  open,
  setOpen,
  queryId,
  onConfirm,
  redirectUrl,
  loadingMessage,
  successMessage,
  confirmationMessage,
  errorMessage,
  isError = false
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const mutation = useMutation(onConfirm, {
    onSettled: () => {
      queryClient.invalidateQueries(queryId);
    },
    onSettled: () => {
      timeoutId = setTimeout(() => {
        setOpen(false);
      }, 3000);
    }
  });
  const { mutateAsync: confirm, isLoading: loading, isError: error, isSuccess: success } = mutation;
  const handleConfirm = async () => {
    await confirm();
  };
  const handleExit = () => {
    if (success && !isError) {
      navigate(redirectUrl);
    }
    mutation.reset();
    clearTimeout(timeoutId);
  };
  return (
    <Dialog
      open={open}
      onClose={() => {
        if (loading) {
          setOpen(true);
        } else {
          setOpen(false);
        }
      }}
      TransitionProps={{
        onExited: handleExit
      }}
    >
      <Stack
        alignItems={'center'}
        justifyContent={'space-evenly'}
        style={{
          minHeight: '15vh',
          gap: '2rem',
          width: isLargeScreen ? '30vw' : isSmallScreen ? '80vw' : '50vw',
          padding: '2rem'
        }}
      >
        {isError ? (
          <Typography>
            <center>
              <h3>
                Something went wrong! <br /> {errorMessage || ''}.
              </h3>

              <ErrorIcon color="error" style={{ fontSize: 100 }} />
            </center>
          </Typography>
        ) : loading ? (
          <>
            <Typography severity="fail">
              <center>
                <h3>{loadingMessage}</h3>
              </center>
            </Typography>
            <PulseLoader size={15} />
          </>
        ) : (
          <>
            {error ? (
              <Typography>
                <center>
                  <h3>
                    Something went wrong! <br /> Please try again or contact your adminstrator.
                  </h3>

                  <ErrorIcon color="error" style={{ fontSize: 100 }} />
                </center>
              </Typography>
            ) : (
              <>
                {success ? (
                  <Typography severity="success">
                    <center>
                      <h3>
                        {successMessage} <br />
                        You will be redirected shortly.
                      </h3>
                      <Checkmark size="xxLarge" />
                    </center>
                  </Typography>
                ) : (
                  <>
                    <Typography severity="fail">
                      <center>
                        <h3>{confirmationMessage}</h3>
                      </center>
                    </Typography>
                    <Stack direction={'row'} width="70%" gap={2}>
                      <Button
                        variant="contained"
                        color="error"
                        fullWidth
                        size="medium"
                        onClick={() => {
                          setOpen(false);
                        }}
                      >
                        No
                      </Button>
                      <Button
                        variant="contained"
                        color="incorta"
                        fullWidth
                        size="medium"
                        onClick={handleConfirm}
                      >
                        Yes
                      </Button>
                    </Stack>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Stack>
    </Dialog>
  );
}

export default ConfirmationDialogue;
